import { TreatmentContact } from "@/components/sections/treatment/TreatmentContact"
import { TreatmentFaqs } from "@/components/sections/treatment/TreatmentFaqs"
import { PageMeta } from "@/components/shared/PageMeta"
import type { TreatmentFaq } from "@/content/treatments-content"
import { planFaq, safeFaq } from "@/content/treatments-content"
import { PAGE_SEO } from "@/lib/seo"

const faqs: TreatmentFaq[] = [
	{
		q: "¿Cuáles son las formas de pago disponibles?",
		a: "Puedes pagar con: (1) tarjetas de crédito o débito y wallets (Apple Pay o Google Pay cuando tu dispositivo lo permita), procesadas de forma segura con Stripe; (2) PayPal; (3) efectivo en tiendas OXXO con un voucher generado al checkout; y (4) transferencia bancaria SPEI a nuestra cuenta, con la referencia que te indicamos. El envío de tu pedido se gestiona una vez confirmado el pago."
	},
	{
		q: "¿Cuándo se confirma mi pago?",
		a: "Con tarjeta, wallet o PayPal, la confirmación suele ser inmediata al autorizar el cobro. Con OXXO, tu pedido queda pendiente hasta que pagues el voucher y Stripe lo confirme. Con transferencia SPEI, queda pendiente hasta que verifiquemos el depósito con la referencia correcta."
	},
	{
		q: "¿Cuánto tarda en llegar mi pedido?",
		a: "El tiempo de entrega depende de tu ubicación. Normalmente los envíos se entregan en 2 a 5 días hábiles una vez confirmado el pago."
	},
	{
		q: "¿Puedo devolver o cambiar un producto?",
		a: "No aceptamos devoluciones ni cambios. Como se trata de productos para el cuidado de la salud, esta medida protege a todos nuestros consumidores: así evitamos que un artículo pueda circular de nuevo después de haber salido de nuestras instalaciones. Puedes adquirir con tranquilidad: cada producto que recibes es totalmente nuevo, sin uso previo, y puedes ingerirlo con plena confianza."
	},
	{
		q: "¿Cómo puedo rastrear mi pedido?",
		a: "Te enviaremos un correo electrónico con el número de guía y un enlace para seguir tu pedido una vez sea enviado."
	},
	{
		q: "¿Es seguro comprar en este sitio?",
		a: "Sí. La conexión del sitio está cifrada. Los datos sensibles de tarjeta o PayPal los procesan Stripe y PayPal en sus entornos seguros; nosotros no guardamos el número completo de tu tarjeta ni tus contraseñas. Tus datos de contacto y envío se usan para completar y dar seguimiento a tu pedido, conforme a nuestra política de privacidad."
	},
	planFaq,
	safeFaq
]

export function ContactoPage(): React.JSX.Element {
	return (
		<div>
			<PageMeta {...PAGE_SEO.contacto} path="/contacto" />
			<TreatmentFaqs faqs={faqs} />
			<TreatmentContact treatmentId="biosany-shalosh-bayom" />
		</div>
	)
}
